import * as types from '../../../lib/actionTypes.es6';

var initialState = {
  organization: null,
  loading: false,
  error: null,
};

export default function orgConfigReducer(state, action) {
  if (state === undefined) { state = initialState; }
  switch (action.type) {
    case types.LOAD_ORG_CONFIG_REQUEST:
      return Object.assign({}, state, { loading: true, error: null });
    case types.LOAD_ORG_CONFIG_SUCCESS:
      return Object.assign({}, state, { loading: false, organization: action.payload });
    case types.LOAD_ORG_CONFIG_FAILURE:
      return Object.assign({}, state, { loading: false, error: action.payload });
    case types.CLEAR_ORG_CONFIG:
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
